import React from 'react'
import Proptypes from 'prop-types'
import style from './CheckedList.module.scss'
import { CardItemList } from 'components/Card'

const CheckedList = ({ checkedItems, onUncheck } = this.props) => {
	return(
		<div className={style['list-checked']}>
			<CardItemList
				items={checkedItems}
				onRemoveItem={onUncheck}
				ItemComponent={({ item }) => <div>{item}</div>}
			/>
		</div>
	)
}

CheckedList.propTypes = {
	checkedItems: Proptypes.array,
	onUncheck: Proptypes.func.isRequired
}

CheckedList.defaultProps = {
	checkedItems: []
}

export default CheckedList
